import type { FunctionComponent } from 'react'
import React, { useContext } from 'react'

import { PillButtonPage } from '../../../../../shared/pages/PillButtonPage'
import { ToolContext } from '../../../../../shared/state/appContext'
import globalStyles from '../../../../../shared/styles/GlobalStyles.module.scss'
import { trackAppointmentBookingSelection } from '../../../../../shared/utils/tracking/tracking'
import { DescribeCaseFlow, LimitedOptionsFlow, MoneyQueryFlow } from '../../../pageFlowData'
import { moneyQueryData } from './data'

export const MoneyQuery: FunctionComponent = () => {
  const { state, dispatch } = useContext(ToolContext)
  const {
    money: { moneyQuery, moneyTopic },
    triage: { type },
  } = state

  const handleTracking = (id: string, index: number) => {
    trackAppointmentBookingSelection(type, MoneyQueryFlow.VIEW_NAME, { id, index })
  }

  const chooseStep = (id: string) => {
    if (id === 'something-else') {
      return LimitedOptionsFlow
    }
    return DescribeCaseFlow
  }

  const handleDispatch = (id: string) => {
    dispatch({ type: 'UPDATE_MONEY_QUERY', data: id })
    const step = chooseStep(id)
    dispatch({ type: 'UPDATE_STEP', data: step.STEP })
    dispatch({ type: 'UPDATE_PROGRESS_VALUE', data: step.PROGRESS_VALUE })
  }

  const handleSubmit = (id: string, index: number) => {
    handleTracking(id, index)
    handleDispatch(id)
  }

  const chooseButtons = () => {
    switch (moneyTopic) {
      case 'social-care':
        return moneyQueryData.socialButtons
      case 'claims-handling':
        return moneyQueryData.claimsButtons
      case 'insurance-products':
        return moneyQueryData.insuranceButtons
      default:
        return moneyQueryData.buttons
    }
  }

  const { imgObj, title } = moneyQueryData
  const buttons = chooseButtons()
  return (
    <div className={globalStyles.fullWidthButton}>
      <PillButtonPage
        buttons={buttons}
        defaultValue={moneyQuery}
        handleSubmit={handleSubmit}
        imgObj={imgObj}
        title={title}
      />
    </div>
  )
}
